import { createAsyncThunk } from '@reduxjs/toolkit';
import { engagementService } from '../../services';
import { prescribersService } from '../../services';

const getEngagementSummary = createAsyncThunk(
    'engagement/getEngagementSummary',
    async (payload, thunkAPI) => {
        try {
            const response = await engagementService.summaryEngagement(
                payload.companyId,
                payload.startRange,
                payload.endRange
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getPrescribers = createAsyncThunk(
    'engagement/getPrescribers',
    async (payload, thunkAPI) => {
        try {
            const response = await engagementService.prescriberEngagement(
                payload.companyId,
                payload.startRange,
                payload.endRange
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getEngagers = createAsyncThunk(
    'engagement/getEngagers',
    async (payload, thunkAPI) => {
        try {
            const response = await engagementService.engagersEngagement(
                payload.companyId,
                payload.startRange,
                payload.endRange,
                payload.size
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getAllEngagers = createAsyncThunk(
    'engagement/getAllEngagers',
    async (payload, thunkAPI) => {
        try {
            const response = await engagementService.allEngagersEngagement(
                payload.companyId,
                payload.startRange,
                payload.endRange
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getTotalEngagement = createAsyncThunk(
    'engagement/getTotalEngagement',
    async (payload, thunkAPI) => {
        try {
            const response = await engagementService.totalEngagement(
                payload.companyId,
                payload.startRange,
                payload.endRange,
                payload.isUnified,
                { page: payload.page, pageSize: payload.pageSize, search: payload.search }
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }

);

// Page turns / search on the provider table. Deliberately separate from
// getDigitalEngagement: that one rebuilds the whole dashboard, this one only
// asks for rows, so switching pages no longer reloads every graph and counter.
const getProviderPage = createAsyncThunk(
    'engagement/getProviderPage',
    async (payload, thunkAPI) => {
        try {
            const response = await engagementService.engagementProviderPage(
                payload.companyId,
                payload.type || 'digital',
                payload.startRange,
                payload.endRange,
                payload.page,
                payload.pageSize,
                payload.search
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getDigitalEngagement = createAsyncThunk(
    'engagement/getDigitalEngagement',
    async (payload, thunkAPI) => {
        try {
            const response = await engagementService.digitalEngagement(
                payload.companyId,
                payload.startRange,
                payload.endRange,
                payload.isUnified,
                // optional; absent unless the caller asks for a page or a search
                { page: payload.page, pageSize: payload.pageSize, search: payload.search }
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getFieldEngagement = createAsyncThunk(
    'engagement/getFieldEngagement',
    async (payload, thunkAPI) => {
        try {
            const response = await engagementService.fieldEngagement(
                payload.companyId,
                payload.startRange,
                payload.endRange,
                payload.isUnified
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getFieldExtendedRegion = createAsyncThunk(
    'engagement/getFieldExtendedRegion',
    async (payload, thunkAPI) => {
        try {
            const response = await engagementService.fieldExtendedRegion(
                payload.companyId,
                payload.startRange,
                payload.endRange,
                payload.isUnified
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getFieldEngagementSegment = createAsyncThunk(
    'engagement/getFieldEngagementSegment',
    async (payload, thunkAPI) => {
        try {
            const response = await engagementService.fieldEngagementSegment(
                payload.companyId,
                payload.segment,
                payload.startRange,
                payload.endRange,
                payload.isUnified
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getAllPrescibers = createAsyncThunk(
    'prescibers/getAllPrescibers',
    async (payload, ThunkAPI) => {
        try{
            const response = await prescribersService.getAllPrescribers(
                payload.companyId,
                payload.position
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);
const getTotalEngagementDigitalEngagementChart = createAsyncThunk(
    'engagement/getTotalEngagementDigitalEngagementChart',
    async (payload, thunkAPI) => {
        try {
            const response = await engagementService.totalEngagementDigitalEngagementChart(
                payload.companyId,
                payload.startRange,
                payload.endRange
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);
export { 
    getEngagementSummary, 
    getPrescribers,
    getEngagers,
    getTotalEngagement,
    getDigitalEngagement,
    getProviderPage,
    getFieldEngagement,
    getFieldExtendedRegion,
    getFieldEngagementSegment,
    getAllPrescibers,
    getTotalEngagementDigitalEngagementChart,
    getAllEngagers
};
